import * as actionTypes from "./actionTypes";

const initialState = {
  loadingBasicElements: false,
  loading: false,
  entryStructures: [],
  colaborators: [],
  columnTypes: [],
  rows: [],
  selects: {},
  concepts: [],
  conceptsTypes: [],
  quantityPerUsedEntryStructure: [],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.RESET_STATE:
      return initialState;
    case actionTypes.GET_BASIC_ELEMENTS:
      return { ...state, loadingBasicElements: true };
    case actionTypes.GET_BASIC_ELEMENTS_FULFILLED:
      return {
        ...state,
        loadingBasicElements: false,
        entryStructures: action.payload.entryStructures,
        colaborators: action.payload.colaborators,
        columnTypes: action.payload.columnTypes,
        quantityPerUsedEntryStructure: action.payload.quantityPerUsedEntryStructure,
      };
    case actionTypes.GET_BASIC_ELEMENTS_REJECTED:
      return { ...state, loadingBasicElements: false };
    case actionTypes.GET_ROWS:
      return { ...state, loading: true };
    case actionTypes.GET_ROWS_FULFILLED:
      return {
        ...state,
        loading: false,
        rows: action.payload.rows,
        concepts: action.payload.concepts,
        conceptsTypes: action.payload.conceptsTypes,
        selects: action.payload.selects,
        quantityPerUsedEntryStructure: action.payload.quantityPerUsedEntryStructure,
      };
    case actionTypes.GET_ROWS_REJECTED:
      return { ...state, loading: false };
    case actionTypes.DELETE_ROWS:
      return { ...state, loading: true };
    case actionTypes.DELETE_ROWS_FULFILLED:
      return {
        ...state,
        loading: false,
      };
    case actionTypes.DELETE_ROWS_REJECTED:
      return { ...state, loading: false };

    case actionTypes.DOWNLOAD:
      return { ...state, loading: true };
    case actionTypes.DOWNLOAD_FULFILLED:
      return { ...state, loading: false };
    case actionTypes.DOWNLOAD_REJECTED:
      return { ...state, loading: false };
    default:
      return state;
  }
}
